/** @format */

import serviceUrls from 'src/constants/serviceUrls';
import { CASES_FILTERS } from 'src/constants/constants';
import axiosRequest from 'src/helpers/axiosRequest';
import { getTodaysDate } from 'src/helpers/date';

export function fetchCases(filters = {}, config) {
  const caseType = sessionStorage.getItem('caseType');
  const taxChatCases = {
    ...filters,
    CaseTypeId: 2,
    dateFrom_input: undefined,
    dateTo_input: undefined,
    caseClientName: filters.caseClientName && filters.caseClientName.length > 0 ? filters.caseClientName : undefined,
    caseContactEmailAddress: filters.caseContactEmailAddress && filters.caseContactEmailAddress.length > 0 ? filters.caseContactEmailAddress : undefined,
    caseType: caseType ? caseType : 'myCase',
  };
  return axiosRequest('post', serviceUrls.CASES_GET_CASES, taxChatCases, { ...config, timeout: 300000 });
}

export function fetchDashboardNewCases(filters = {}, config) {
  const caseType = sessionStorage.getItem('caseType');
  const taxChatCases = {
    ...filters,
    CaseTypeId: 2,
    caseType: caseType ? caseType : 'myCase',
  };
  return axiosRequest('post', serviceUrls.CASES_GET_DASHBOARD_NEW_CASES, taxChatCases, { ...config, timeout: 300000 });
}

export function fetchDetailsHeader(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_DETAILS_HEADER, { caseManagerId }, null, null, { caseManagerId });
}

export function fetchDetailsLinkedCasesFlag(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_LINKED_CASE_SHOWFLAG, { caseManagerId }, null, null, { caseManagerId });
}

export function fetchCaseDetail(caseManagerId = '') {
  return axiosRequest(
    'get',
    serviceUrls.CASES_GET_CASE_DETAIL,
    {
      languageId: 1,
      caseManagerId,
    },
    null,
    null,
    { caseManagerId },
  );
}

export function updateExperianValidated(caseManagerId = '', experianValidatedId) {
  return axiosRequest(
    'post',
    serviceUrls.CASES_UPDATE_EXPERIAN_VALIDATED,
    {
      experianValidatedId,
      caseManagerId,
    },
    null,
    null,
    { caseManagerId },
  );
}

export function getPrimaryCaseContacts(caseManagerId = '', clientId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_PRIMARY_CASE_CONTACTS, { caseManagerId, engagementId: clientId }, null, null, {
    caseManagerId,
    engagementId: clientId,
  });
}

export function getSecondaryCaseContacts(caseManagerId = '', clientId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_SECONDARY_CASE_CONTACTS, { caseManagerId, engagementId: clientId }, null, null, {
    caseManagerId,
    engagementId: clientId,
  });
}

export function getTeritaryCaseContacts(caseManagerId = '', clientId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_TERITARY_CASE_CONTACTS, { caseManagerId, engagementId: clientId }, null, null, {
    caseManagerId,
    engagementId: clientId,
  });
}

export function getCOEMemberCaseContacts(caseManagerId = '', clientId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_COE_MEMBER_CASE_CONTACTS, { caseManagerId, engagementId: clientId }, null, null, {
    caseManagerId,
    engagementId: clientId,
  });
}

export function getDelegateCaseContacts(caseManagerId = '', clientId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_DELEGATE_CASE_CONTACTS, { caseManagerId, engagementId: clientId }, null, null, {
    caseManagerId,
    engagementId: clientId,
  });
}

export function upadteDelegateProfileservice(caseManagerId = '', oldDelegateProfileKey = '', delegateProfileKey = '', deActivate) {
  return axiosRequest('post', serviceUrls.UPDATE_DELEGATE_PROFILE, {
    caseManagerId,
    oldDelegateProfileKey,
    delegateProfileKey,
    deActivate,
  });
}


export function updateExtensionDetails(extensionDetails) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_EXTENSION_DETAILS, {
    ...extensionDetails
  }, null, null, { caseManagerId: extensionDetails.caseManagerId });
}

export function fetchCaseQuestionnaireList(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_QUESTIONNAIRE_LIST, { caseManagerId }, null, null, { caseManagerId });
}

export function fetchAdditionalInfo(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_ADDITIONALINFO, { caseManagerId }, null, null, { caseManagerId });
}

export function fetchGetCaseStatus() {
  return axiosRequest('get', serviceUrls.CASES_GET_CASE_STATUS);
}

export function fetchGetQuestionnaireAccess() {
  return axiosRequest('post', serviceUrls.CASES_GET_QUESTIONNAIRE_ACCESS);
}

export function fetchFieldData(field = CASES_FILTERS.ENGAGEMENTS) {
  return axiosRequest('get', serviceUrls[`GET_${field}`]);
}

export function searchCases(email) {
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_SERVICE, {
    email: email,
  });
}

export function fetchCaseClients() {}

export function fetchCaseEntities() {
  return axiosRequest('get', serviceUrls.CASES_GET_ENTITY);
}

export function fetchCasePathways() {
  return axiosRequest('get', serviceUrls.CASES_GET_PATHWAY);
}

export function fetchCaseDaysOld() {
  return axiosRequest('get', serviceUrls.CASES_GET_DAYSOLD);
}

export function fetchCasePhases() {
  return axiosRequest('get', serviceUrls.CASES_GET_PHASE);
}

export function fetchStatusId() {
  return axiosRequest('get', serviceUrls.CASES_GET_STATUS_ID);
}

export function getCaseFiltersAPI(payload) {
  return axiosRequest('get', serviceUrls.CASES_GET_FILTERS, null, null, null, {
    caseType: payload,
  });
}

export function getLobbyMessageYear(payload) {
  return axiosRequest('get', serviceUrls.LOBBYMESSAGE_GET_YEAR, null, null, null, {
    caseType: payload,
  });
}

export function getLanguageLobbyMessage(payload) {
  return axiosRequest('get', serviceUrls.GET_LANGUAGES_LOBBYMESSAGE, {
    profileKey:payload
  });
}

export function getImmigrationPathway() {
  return axiosRequest('get', serviceUrls.CASES_GET_PATHWAYS);
}

export function fetchImmigrationCasePathway(payload) {
  return axiosRequest('get', serviceUrls.CASES_GET_CASE_PATHWAYS, payload);
}

export function saveCasePathway(payload) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_PATHWAYS, payload);
}

export function fetchCaseMessagesCounts(params) {
  const filter = !!(params.dateFrom || params.dateTo || params.engagement || params.priority);

  return axiosRequest(
    'get',
    serviceUrls.MESSAGING_INBOX_SERVICE,
    {
      pageSize: 100,
      pageNumber: 1,
      ...params,
      filter,
    },
    null,
    null,
    { caseManagerId: params.caseManagerId },
  );
}

export function updateReturnGroupDetails(returnGroupDetails) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_RETURN_GROUP_DETAILS, {
   ...returnGroupDetails
  });
}

export function updateOtherDetails(returnGroupDetails) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_OTHER_DETAILS, {
   ...returnGroupDetails
  }, null, null, { caseManagerId: returnGroupDetails.caseManagerId });
}

export function setRelatedReturn(caseManagerId = '', profileKey = '', relatedReturn = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_ISPRIMARY, {
    caseManagerId,
    profileKey,
    relatedReturn,
  });
}

export function setCaseContact(caseManagerId = '', profileId = '', caseType = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_CONTACT, {
    caseManagerId,
    profileId,
    caseType,
  });
}

export function setCaseDelegate(caseManagerId = '', delegateProfileKey = '', deActivate) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_DELEGATE, {
    caseManagerId,
    delegateProfileKey,
    deActivate,
  });
}

export function setCaseStatus(obj) {
  const {caseManagerId,caseStatusId,reasonForClosureId,reasonForClosureOtherReason} = obj;
  return axiosRequest('post', serviceUrls.CASES_UPDATE_STATUS, {
    caseManagerId,
    caseStatusId,
    reasonForClosureId,
    reasonForClosureOtherReason
  });
}

export function updateQuestionnaireAccess(caseManagerId = '', questionnaireAccessId = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_QUESTIONNAIRE_ACCESS, {
    caseManagerId,
    questionnaireAccessId,
  });
}

export function UpdateCaseOnholdResponseBy(caseManagerId = '', OnHoldResponseById = '') {
  return axiosRequest('post', serviceUrls.UPDATE_ONHOLD_RESPONSE_BY, {
    caseManagerId,
    OnHoldResponseById,
  });
}

export function UpdateCaseReturnApprovalById(caseManagerId = '', returnApprovalById = '') {
  return axiosRequest('post', serviceUrls.UPDATE_RETURN_APPROVAL_BY, {
    caseManagerId,
    returnApprovalById,
  });
}

export function UpdateCasePaymentDetails(paymentObj) {
  return axiosRequest('post', serviceUrls.UPDATE_CASE_PAYMENT_DETAILS, {
    ...paymentObj
  },
  null,
  null,
  {caseManagerId:paymentObj.caseManagerId}
);
}

export function setConsentStatus(caseManagerId = '', consentStatusId = '') {
  return axiosRequest('post', serviceUrls.CONSENT_UPDATE_STATUS, {
    caseManagerId,
    consentStatusId,
  },
  null,
  null,
  {caseManagerId});
}

export function setCaseFrequency(caseManagerId = '', chaseFrequencyId = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_FREQUENCY, {
    caseManagerId,
    caseFrequencyId: chaseFrequencyId,
  });
}

export function setAllowedAccess(profileKey = '', allowedAccessId = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_ALLOWED_ACCESS, {
    profileKey,
    clientAllowedAccess: allowedAccessId,
  });
}

export function setTaxDay(caseManagerId = '', taxDay = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_TAXDAY, {
    taxDay,
    caseManagerId,
  });
}

export function setCaseManagerStatus(caseManagerId = '', caseStatusId = '', reasonForStatusChange = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_MANAGER_STATUS, {
    caseManagerId,
    caseStatusId: caseStatusId,
    ReasonForStatusChange: reasonForStatusChange,
  });
}

export function saveCaseDetail(params) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_CASE_DETAIL, params, null, null, {
    assigneeServicePlanGlobalId: params.assigneeServicePlanGlobalId,
    organizerTypeId: params.organizerTypeId,
    caseManagerId: params.caseManagerId,
  });
}

export function updateCasePhaseService(params) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_CASE_PHASE, params, { timeout: 300000 }, null, {
    caseManagerId: params.caseManagerId,
  });
}

export function fetchCasePhasesService(params) {
  return axiosRequest('get', serviceUrls.CASES_CASE_PHASES, params, null, null, params);
}

export function fetchCaseConsents(params) {
  return axiosRequest('get', serviceUrls.GET_CONSENT_FOR_EYUSER, params, null, null, params);
}

export function updateDelegateConsentForEYUser(params) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_DELEGATE_CONSENT, params, null, null, { caseManagerId: params.caseManagerId });
}

export function openDocument(params) {
  return axiosRequest(
    'get',
    serviceUrls.OPEN_CONSENT_DOCUMENT,
    {
      caseManagerId: params.caseManagerId,
      consertVersionId: params.consentVersionId,
    },
    {
      timeout: 180000,
    },
    null,
    params,
  );
}

export function fetchFilterCasePhases(params) {
  return axiosRequest('get', serviceUrls.CASES_FILTER_CASE_PHASES, params, null, null, params);
}

export function fetchFilterEyStatus(params) {
  return axiosRequest('get', serviceUrls.CASES_FILTER_GET_EYSTATUS, params, null, null, params);
}

export function fetchFilterPhaseEyStatus(params) {
  return axiosRequest('get', serviceUrls.CASES_PHASE_EYSTATUS_COUNTRYYEARSERVICE, params, null, null, params);
}

export function fetchFilterCountryByCaseYear(params) {
  return axiosRequest('get', serviceUrls.CASES_COUNTRY_GET_CASEYEAR, params, null, null, params);
}

export function fetchCaseYearByCountryId(params) {
  return axiosRequest('get', serviceUrls.CASES_GET_YEAR_BYCOUNTRY, params, null, null, params);
}

export function fetchProductTypeByCaseYear(params) {
  return axiosRequest('get', serviceUrls.CASES_PRODUCT_TYPE_YEAR_COUNTRY, params, null, null, params);
}

export function getLobbyMessageByProductTypeandLanguage(params) {
  return axiosRequest('get', serviceUrls.CASES_GETLOBBYMESSAGE, params, null, null, params);
}


export function fetchFilterServiceType(params) {
  return axiosRequest('get', serviceUrls.CASES_SERVICE_TYPE, params, null, null, params);
}

export function downloadAnswerKeyXML(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_DOWNLOAD_ANSWERKEY + caseManagerId, { timeout: 180000 }, null, null, null);
}

export function deliverReturnStatus(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_DELIVER_RETURN, { caseManagerId }, { timeout: 480000 }, null, null);
}

export function deliverReturnPriceInfoService(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.CASES_DELIVER_RETURN_PRICE_DETAIL, { caseManagerId }, { timeout: 180000 }, null, { caseManagerId });
}

export function syncSurePrepBinderStatus(params) {
  return axiosRequest('post', serviceUrls.SYNC_SUREPREP_BINDER, {
    caseManagerId: params.caseManagerId,
    binderID: params.binderID,
  },
  null,
  null,
  { caseManagerId: params.caseManagerId });
}

export function updateLobbyMessageService(params) {
  return axiosRequest('post', serviceUrls.UPDATE_LOBBY_MESSAGE, {
   ...params
  });
}

export function resetBinderCreateStatus(caseManagerId = '') {
  return axiosRequest('post', serviceUrls.CASES_RESET_BINDER_CREATE, 
    { caseManagerId }, 
    { timeout: 300000 }, 
    null, 
    { caseManagerId });
}

export function resetDocumentsUploadStatus(caseManagerId = '') {
  return axiosRequest('post', serviceUrls.CASES_RESET_DOCUMENTS_UPLOAD, { caseManagerId }, { timeout: 300000 }, null, { caseManagerId });
}

export function deleteCaseService(params) {
  return axiosRequest('post', serviceUrls.DELETE_CASE, {
    ...params
  },
  null,
  null,
  { caseManagerId: params.caseManagerId }
  );
}


export function fetchEYCaseStatus(options) {
  return axiosRequest('get', serviceUrls.CASES_GET_EYSTATUS, { ...options }, null, null, { caseManagerId: options.caseManagerId });
}

export function initiateDocusignStatus(caseManagerId = '') {
  return axiosRequest('post', serviceUrls.INITIATE_DOCUSIGN_STATUS, 
    { caseManagerId }, 
    null, 
    null, 
    { caseManagerId });
}

export function initiateEFileStatus(caseManagerId = '') {
  return axiosRequest('post', serviceUrls.INITIATE_EFILE_STATUS, {
    caseManagerId,
  });
}

export function downloadSurePrepBinderService(caseManagerId) {
  return axiosRequest('post', serviceUrls.DOWNLOAD_BINDER, {
    caseManagerId,
  },
  null,
  null,
  { caseManagerId }
  );
}

export function setFavoriteMarkService(params) {
  return axiosRequest('post', serviceUrls.FAVORITE_MARK, {
    caseManagerId: params.caseManagerId,
    IsFavorite: params.IsFavorite,
  },
  null,
  null,
  { caseManagerId: params.caseManagerId });
}

export const getTaxcaddyList = options =>
  axiosRequest(
    'get',
    serviceUrls.GET_TAXCADDY_LOGS_LIST,
    {
      ...options,
    },
    null,
    null,
    { caseManagerId: options.caseManagerId },
  );

export const setTaxcaddyLogSubscribe = caseManagerId =>
  axiosRequest(
    'post',
    serviceUrls.SET_TAXCADDY_SUBSCRIBE,
    {
      caseManagerId,
    },
    null,
  );

export const setTaxcaddyLogUnsubscribe = caseManagerId =>
  axiosRequest(
    'post',
    serviceUrls.SET_TAXCADDY_UNSUBSCRIBE,
    {
      caseManagerId,
    },
    null,
  );

export const setUpdateStatusDate = options =>
  axiosRequest(
    'post',
    serviceUrls.UPDATE_SP_STATUS_DATE,
    {
      ...options,
    },
    null,
    null,
    { caseManagerId: options.caseManagerId },
  );
  
  export function fecthMissingInformationDetails(caseManagerId = '',data={}) {
    return axiosRequest(
      'get',
      serviceUrls.GET_MISSING_INFORMATION,
      {
        caseManagerId,
        ...data
      },
      null,
      null,
      { caseManagerId },
    );
  }

  export function addMissingInfoDialog(params) {
    return axiosRequest('post', serviceUrls.ADD_MISSING_INFORMATION_DIALOG, {
     ...params
    },
    null,
    null,
    { caseManagerId: params.caseManagerId },);
  }

  export function setFollowUpAcknowledgeService(params) {
    return axiosRequest('post', serviceUrls.SET_FOLLOW_UP_ACKNOWLEDGE, {
     ...params
    },
    null,
    null,
    { caseManagerId: params.caseManagerId },);
  }

  export function convertMissingInfoToPDF(data) {
    return axiosRequest('post', serviceUrls.CONVERT_MISSING_INFO_TO_PDF, {...data,overViewId : 0} ,{}, null, { dateUTC: getTodaysDate('utc'),
      caseManagerId: data.caseManagerId,
      overViewId : 0
     }
    );
  }

  export function saveMissingInfoService(data) {
    return axiosRequest('post', serviceUrls.SAVE_MISSING_INFORMATION, {...data,overViewId : 0} ,{}, null, { dateUTC: getTodaysDate('utc'),
      caseManagerId: data.caseManagerId,
      overViewId : 0
     }
    );
  }

  export function editMissingInfoQuestionService(data) {
    return axiosRequest('post', serviceUrls.EDIT_MISSING_INFO_QUESTION, {
      missingInfoDetailsId: data.missingInfoDetailsId,
      question: data.question,
      caseManagerId: data.caseManagerId 
    }, null, null, { caseManagerId: data.caseManagerId });
  }

  export function deleteMissingInfoQuestionService(data) {
    return axiosRequest('post', serviceUrls.DELETE_MISSING_INFO_QUESTION, {
      caseManagerId: data.caseManagerId,
      missingInfoDetailsId: data.missingInfoDetailsId,
    }, null, null, { caseManagerId: data.caseManagerId });
  }

  export function updateCasePaceDetails(casePaceDetails) {
    return axiosRequest('post', serviceUrls.CASES_UPDATE_PACE_DETAILS, {
    ...casePaceDetails
    },
    null,
    null,
    {caseManagerId : casePaceDetails.caseManagerId});

}
